export const saleRoutes = {
	sales: (query: string) => `/sales/${query ? `?${query}` : ''}`,
	salesExport: '/sales/export/',
	salesRequestPayout: '/sales/request_payout/',
	salesRecalculateCommission: '/sales/recalculate_commission/',
	sale: (id: string) => `/sales/${id}/`,
	saleHistory: (id: string) => `/sales/${id}/history/`
} as const
